type DataItem = {
	[key: string]: string | number;
};
type Props = {
	data: DataItem[];
	columns: string[];
};
export const downloadCSV = ({ data, columns }: Props) => {
	let csvContent = columns.join(',') + '\n';

	data.forEach(row => {
		const rowData = columns.map(col => {
			const value = row[col];
			// Handle undefined, null, or empty values
			if (value === undefined || value === null || value === '') {
				return '';
			}
			// Escape special characters and wrap in quotes if necessary
			const stringValue = String(value).replace(/"/g, '""');
			return stringValue.includes(',') || stringValue.includes('"') || stringValue.includes('\n')
				? `"${stringValue}"`
				: stringValue;
		});
		csvContent += rowData.join(',') + '\n';
	});

	const blob = new Blob([csvContent], { type: 'text/csv;charset=utf-8;' });
	const url = URL.createObjectURL(blob);
	const link = document.createElement('a');
	link.setAttribute('href', url);
	link.setAttribute('download', 'data.csv');
	document.body.appendChild(link);
	link.click();
	document.body.removeChild(link);
	URL.revokeObjectURL(url);
};
